import type {Section} from "@/generated/api";

// Props du <div> qui enveloppe un bloc : l'ancre posée en back office (bouton « ancre » de l'en-tête du bloc) en fait la cible des liens `#ancre`,
// sur tous les blocs, avec ou sans titre. Le scroll tombe sous le header et la barre sticky grâce au `scrollPaddingTop` de `styles/global.ts`.
// La classe contient « section » exprès : la règle `div[id]:not([class*='section'])` de `styles/global.ts` (décalage de -20px pour les ancres de
// paragraphes dans les textes) ne doit pas s'appliquer à un bloc entier, dont le haut doit s'aligner exactement sous la barre.
export const sectionAnchorProps = (section: Section) =>
  "anchor" in section && section.anchor
    ? {id: section.anchor, className: "section-anchor"}
    : {};
